// TUT-450 — os feedbacks e os anexos.
import { demoApi } from "../demo-data";
import type {
  CreateFeedbackInput,
  Feedback,
  FeedbackListQuery,
  FeedbackListResponse,
} from "../types";
import { request } from "./infra";

// Lido aqui, e não importado: o empacotador só dobra a constante no módulo
// que a escreve, e é isso que tira o demo do build de produção (TUT-448).
const useDemoApi = import.meta.env.VITE_API_MODE === "demo";

export const apiDosFeedbacks = {
  feedbacks(query: FeedbackListQuery = {}): Promise<FeedbackListResponse> {
    if (useDemoApi) return demoApi.feedbacks(query);
    const params = new URLSearchParams({
      page: String(query.page ?? 1),
      pageSize: String(query.pageSize ?? 20),
    });
    if (query.search) params.set("search", query.search);
    for (const status of query.statuses ?? []) params.append("status", status);
    return request<FeedbackListResponse>(`/feedbacks?${params}`);
  },
  createFeedback(input: CreateFeedbackInput): Promise<Feedback> {
    if (useDemoApi) return demoApi.createFeedback(input);
    return request<Feedback>("/feedbacks", {
      method: "POST",
      body: JSON.stringify(input),
    });
  },
  /** TUT-344 — a URL (curta, `inline`) de uma imagem de evidência. */
  feedbackAttachmentUrl(feedbackId: string, attachmentId: string): Promise<string> {
    if (useDemoApi) return demoApi.feedbackAttachmentUrl(feedbackId, attachmentId);
    return request<{ url: string }>(
      `/feedbacks/${encodeURIComponent(feedbackId)}/attachments/${encodeURIComponent(attachmentId)}`,
    ).then((resposta) => resposta.url);
  },
};
